import styled from 'styled-components'
import {
  textStyleSizeOptions,
  textStyleWeightOptions,
  textStyleSizeStyleOptions,
  textStyleWeightStyleOptions
} from './constants'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const Heading = styled.span`
  ${({ loading }) => (loading ? 'gap: 8px;' : '')}
  ${({ size = textStyleSizeOptions['TEXT-R'] }) => textStyleSizeStyleOptions[size]}
  ${({ weight = textStyleWeightOptions['TEXT-400'] }) => textStyleWeightStyleOptions[weight]}
  color: ${(color) => color};
  white-space: pre;
`

const TextContainer = styled.p`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export { Heading, Container, TextContainer }
